<template>
  <div id="user-list">
    <!-- list filters -->
    <v-card>
      <v-card-text>
        <CRUDTable
          ref="crudTableRef"
          :remote-create-item="createItem"
          :remote-update-item="updateItem"
          :remote-delete-item="deleteItem"
          :remote-get-item="getItem"
          :fetch-list="fetchList"
          edit-with="1000px"
          :form-config="formConfig"
          :input-configs="inputConfigs"
          :enable-search="false"
          :refresh-interval-seconds="30"
          @reset="handleReset"
          @openEditDialog="onEditDialog"
        >
          <template v-slot:item.processPercentage="{ value, item }">
            <v-progress-linear
              height="20"
              :value="value"
              striped
            >
              <span class="font-white">{{ Math.ceil(item.processPercentage) }}%</span>
            </v-progress-linear>
          </template>
          <template v-slot:item.prependActions="{ item }">
            <span v-if="item.commissionBatchStatusID>2">
              <v-icon
                class="action-icon mr-2"
                @click="openReport(item.id)"
              >
                mdi-microsoft-excel
              </v-icon>
              <v-icon
                :key="item.id"
                :class="getStatusClass(item)"
                @click="openStatusDialog(item)"
              >
                mdi-check-decagram
              </v-icon>
            </span>
          </template>
        </CRUDTable>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="updateStatusDialog"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Update Batch Status</span>
        </v-card-title>
        <v-card-text>
          Are you sure you to <span class="font-weight-black text-h6">{{ actionMessage }}</span> the status?
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="updateStatus"
          >
            Save
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="closeStatusDialog"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { onMounted, ref, nextTick } from 'vue'
import { createItem, deleteItem, fetchList, getItem, updateItem } from '@/api/commissionBatch'
import CRUDTable from '@/components/CRUD/CRUDTable'
import { fetchLocalBatchStatus } from '@/api/commissionBatchStatus'
import { listCoach } from '@/api/coachAttendance'
import moment from '@/utils/moment'
import { loading } from '@/utils/helper'

const crudTableRef = ref(null)
const updateStatusTitle = ref('')

const updateStatusDialog = ref(false)

function getStatusClass(item) {
  let className = 'action-icon mr-2 '
  if (item.commissionBatchStatusID === 4) {
    className += 'font-primary'
  }

  return className
}

// const loading = ref(false)
const searchKeyWord = ref('')

const commissionBatchStatusList = ref([])
const formConfig = ref({
  title: 'Commission Batch',
  headers: [
    { value: 'id', text: 'id', width: '100px' },
    { value: 'selectedMonth', text: 'Selected Month', width: '160px' },
    { value: 'createdAt', text: 'CreateAt', width: '150px' },
    { value: 'commissionBatchStatusID', text: 'Batch Status', width: '150px' },
    { value: 'processPercentage', text: 'Process', width: '200px' },
    { value: 'remark', text: 'Remark' },
    { value: 'actions', text: 'Actions', sortable: false, width: '200px' },
  ],
  customColumns: [
    {
      name: 'createdAt',
      callback(createdAt) {
        // console.log('selectedMonth', selectedMonth)

        return moment(createdAt).format('yyyy-MM-DD')
      },
    },
    {
      name: 'processPercentage',
    },
    {
      name: 'selectedMonth',
      callback(selectedMonth) {
        // console.log('selectedMonth', selectedMonth)

        return moment(selectedMonth).format('yyyy-MM')
      },
    },
    {
      name: 'commissionBatchStatusID',
      callback(commissionBatchStatusID) {
        // console.log('commissionBatchStatusID', commissionBatchStatusID)
        for (let index = 0; index < commissionBatchStatusList.value.length; index += 1) {
          const commissionBatchStatus = commissionBatchStatusList.value[index]
          if (commissionBatchStatus.id === commissionBatchStatusID) {
            return commissionBatchStatus.name
          }
        }

        return ''
      },
    },
  ],
})

const userRecordList = ref([])
const defaultInputConfigs = [
  {
    md: 12,
    propName: 'selectedMonth',
    label: 'Month',
    type: {
      name: 'datepicker',
      disabled: false,
    },
  },
  {
    md: 12,
    propName: 'remark',
    label: 'Remark',
    type: {
      name: 'textarea',
    },
  },
]
const inputConfigs = ref(JSON.parse(JSON.stringify(defaultInputConfigs)))
function handleReset() {
  console.log('handleReset')
  nextTick(() => {
    const configs = JSON.parse(JSON.stringify(defaultInputConfigs))
    configs[0].disabled = false
    inputConfigs.value = configs
    console.log('inputConfigs', inputConfigs)
  })
}
function onEditDialog(action) {
  console.log('action', action)
  nextTick(() => {
    if (action === 'edit') {
      const configs = JSON.parse(JSON.stringify(defaultInputConfigs))
      configs[0].disabled = true
      inputConfigs.value = configs
      console.log('inputConfigs', inputConfigs)
    }
  })
}

onMounted(() => {
  fetchLocalBatchStatus().then(res => {
    const { items } = res.data
    for (let index = 0; index < items.length; index += 1) {
      const item = items[index]
      commissionBatchStatusList.value.push({
        label: item.name,
        value: item.id,
        itemValue: item.id,
        itemName: item.name,
        ...item,
      })
    }
  })
  listCoach({}).then(res => {
    const { items } = res.data
    for (let index = 0; index < items.length; index += 1) {
      const item = items[index]
      userRecordList.value.push({
        label: item.fullName,
        value: item.id,
        itemValue: item.id,
        itemName: item.fullName,
        ...item,
      })
    }
  })
})

function openReport(batchId) {
  const w = window.open(`${window.location.origin}/MANAGE_CommissionReportExcel?commissionBatchID=${batchId}`, '', 'width=200,height=100')
  setTimeout(() => {
    w.resizeTo(screen.width, screen.height)
  }, 1000)
}

const defaultItem = {
  id: 0,
  selectedMonth: '',
  commissionBatchStatusID: 0,
  processPercentage: 0,
}
const record = ref({ ...defaultItem })
const actionMessage = ref('confirm')
function openStatusDialog(item) {
  updateStatusDialog.value = true
  actionMessage.value = 'confirm'
  record.value = { ...item }
  record.value.commissionBatchStatusID = 4
  if (item.commissionBatchStatusID === 4) {
    actionMessage.value = 'rollback'
    record.value.commissionBatchStatusID = 3
  }
  console.log('record.value', record.value)
}
function closeStatusDialog() {
  updateStatusDialog.value = false
  record.value = { ...defaultItem }
}

function updateStatus() {
  loading(true)
  updateItem(record.value).then(() => {
    nextTick(() => {
      crudTableRef.value.fetchData().then(() => {
        closeStatusDialog()
        loading(false)
      })
    })
  }).finally(() => {
    loading(false)
  })
}

</script>
<style>
.font-white{
  color: white;
}
.font-primary{
  color: #1976d2 !important;
}
</style>
